/**
 * isLedgerProposalTransactionId
 *
 * Whether a transaction id is one a proposal's commit posts: an allocation `alloc:{proposalId}:{claimId}` or a
 * proposal adjustment `adj:{proposalId}:{targetId}`, the forms `ledgerTransactionId` mints for those sources. Both
 * change what counts as paid, so reversing one needs the definition's `commitRight`; a manual adjustment
 * (`man:{uid}:{entryKey}`) is not one. The gate relies on an invariant: no kind a caller can post through
 * `ledgerPostTransactions` carries an `alloc:` or `adj:` id. That callable refuses allocations, requires an
 * `entryKey` on every adjustment so `ledgerTransactionProblem` holds it to a `man:` id, and pins accruals,
 * receipts and reversals to their own forms; so the prefix alone says a proposal's commit posted it.
 * Consumers: `ledgerPostTransactions` (the server gate) and `LedgerReverseButton` (the matching UI gate). No I/O.
 */

function isLedgerProposalTransactionId(transactionId: string): boolean {
    return transactionId.startsWith('alloc:') || transactionId.startsWith('adj:');
}

export { isLedgerProposalTransactionId };
